import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { FidelityAdvantageValidationModel } from 'src/app/models/configurators-2d/applications/kitchen/validation/base-validation-project-info';
import {
  FidelityCardPointSimulationDto,
  FidelityCardTypeEnum,
  GetCustomerFidelityInfoNouveauPointInput,
} from 'src/app/services/fidelity/fidelity';
import { FidelityService } from 'src/app/services/fidelity/fidelity.service';
import { FeatureSettingsService } from 'src/app/services/feature-settings/feature-settings.service';
import { logError } from 'src/app/services/helpers/sentry.helper';
import { TunnelService } from 'src/app/services/tunnel.service';

@Component({
  selector: 'ng-fidelity-advantage',
  templateUrl: './fidelity-advantage.component.html',
})
export class FidelityAdvantageComponent implements OnInit, OnDestroy {
  @Input() model$: Observable<FidelityAdvantageValidationModel>;
  private _modelSubscription: Subscription;

  public model: FidelityAdvantageValidationModel;

  fidelityCardPointSimulationInfo: FidelityCardPointSimulationDto;
  isLoading: boolean = true;
  customerId: string;
  amount: number;

  constructor(
    private readonly fidelityService: FidelityService,
    private readonly featureSettingsService: FeatureSettingsService,
    private readonly tunnelService: TunnelService
  ) {}

  ngOnInit(): void {
    this._modelSubscription = this.model$.subscribe(async model => {
      if (model) {
        this.customerId = model.customer.kfId;
        this.amount = model.amount;
        await this.getCustomerFidelityNouveauInfo(this.customerId);
      }
    });
  }

  ngOnDestroy(): void {
    this._modelSubscription?.unsubscribe();
  }

  async getCustomerFidelityNouveauInfo(id: string) {
    if (!(await this.featureSettingsService.isFidelityEnabled())) {
      this.isLoading = false;
      return;
    }

    const input: GetCustomerFidelityInfoNouveauPointInput = {
      customerId: id,
      amount: Math.floor(this.amount),
    };
    this.isLoading = true;
    if (this.amount != undefined && this.customerId != null) {
      try {
        this.fidelityCardPointSimulationInfo = new FidelityCardPointSimulationDto(
          await this.fidelityService.getCustomerFidelityCardInfoNouveauPoint(input)
        );
        this.tunnelService.kitchenTunnelData?.fidelityCardPoint.push(this.fidelityCardPointSimulationInfo);
        this.tunnelService.storageTunnelData?.fidelityCardPoint.push(this.fidelityCardPointSimulationInfo);
        this.fidelityCardPointSimulationInfo.amount = input.amount;
      } catch (error) {
        logError(error);
      } finally {
        this.isLoading = false;
      }
    }
  }

  isFreeCard(type: FidelityCardTypeEnum): boolean {
    return (
      type == FidelityCardTypeEnum.AUCUNE ||
      type == FidelityCardTypeEnum.GRATUITE ||
      type == FidelityCardTypeEnum.AUCUNE0
    );
  }

  isPremium(type: FidelityCardTypeEnum): boolean {
    return type == FidelityCardTypeEnum.PREMIUM;
  }
}
